import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { volumes } from '../data/content';
export function Volumes() {
  return <section id="volumes" className="w-full bg-cream px-5 py-16 sm:px-8 md:py-20" data-id="element-266" data-mp="1lx4paarhat6p">
      <div className="mx-auto max-w-3xl text-center" data-id="element-267" data-mp="185q1lqmmm3tb">
        <p className="text-[12px] font-extrabold uppercase tracking-[0.16em] text-gold-deep" data-id="element-268" data-mp="1c4p7pek3g6mc">
          📦 What’s inside
        </p>
        <h2 className="mt-3 font-display text-[28px] font-bold leading-tight text-ink sm:text-4xl" data-id="element-269" data-mp="1zvkws3x60npw">
          The 6 volumes inside Resin Architect™
        </h2>
      </div>

      <div className="mx-auto mt-10 max-w-4xl space-y-5" data-id="element-270" data-mp="1qtbkp9m90mae">
        {volumes.map(volume => <article key={volume.number} className="rounded-3xl border border-ink/10 bg-white p-5 sm:p-7" data-id="element-271" data-mp="1vsofcgjd2xnj">
            <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-gold-deep" data-id="element-272" data-mp="fhas1jm9kdpd">
              {volume.number}
            </p>
            <h3 className="mt-2 font-display text-[22px] font-bold leading-tight text-ink sm:text-[28px]" data-id="element-273" data-mp="3o7n4uwiot5v3">
              {volume.title}
            </h3>
            <p className="mt-2 font-display text-[16px] italic leading-snug text-clay sm:text-lg" data-id="element-274" data-mp="3jb6gq2bhmri0">
              {volume.promise}
            </p>

            <div className="my-5 hairline" data-id="element-275" data-mp="3t6q7kab72zzw" />

            <p className="text-[15px] leading-relaxed text-ink/80" data-id="element-276" data-mp="3t5yf38cw9idu">{volume.description}</p>

            <p className="mt-5 text-[11px] font-extrabold uppercase tracking-[0.14em] text-ink/50" data-id="element-277" data-mp="b023mnrvsivt">
              {volume.insideLabel}
            </p>
            <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-278" data-mp="krzji7tu3z0v">
              {volume.inside.map(item => <li key={item} className="flex items-start gap-2 text-[14px] text-ink/85" data-id="element-279" data-mp="frtqoobtw6h7">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-280" data-mp="trmlovue18uz" />
                  <span data-id="element-281" data-mp="pqsv1upk9fye">{item}</span>
                </li>)}
            </ul>

            {volume.footnote && <p className="mt-5 rounded-xl bg-ink px-4 py-3 text-center text-[11px] font-bold uppercase tracking-[0.1em] text-gold-light" data-id="element-282" data-mp="wuser4wwtthi">
                {volume.footnote}
              </p>}
          </article>)}
      </div>

      <div className="mx-auto mt-10 max-w-xl" data-id="element-283" data-mp="16q2ibx2yi8xe">
        <CtaButton label="Get access to the complete system" data-id="element-284" data-mp="1bjowjtorqkvb" />
      </div>
    </section>;
}